import React, { useState, useEffect } from 'react'
import '../css/components/Cart.css';
import extraImg from '../assets/empty-cart.gif';
import ResponseMsg from '../general/ResponseMsg';
import SuccessImg from '../assets/order-success.gif';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';
import Default from '../assets/default.jpg';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
export const generateOrderPDF = async (elementId) => {
    const input = document.getElementById(elementId);

    // Ensure the canvas scales well for high resolution
    const canvas = await html2canvas(input, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    
    // Get the image properties to adjust the size in the PDF
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    // Return PDF instance
    return pdf;
};



const Cart = ({userData}) => {
    const navigate = useNavigate();
    const [cart, setCart] = useState([]);
    const [newUserData, setNewUserData] = useState([]);
    const [response, setResponse] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [confirmOrder, setConfirmOrder] = useState(false);
    const [orderRemark, setOrderRemark] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const savedCart = JSON.parse(localStorage.getItem('cart'));

        if (savedCart && Array.isArray(savedCart)) {
            setCart(savedCart);
        } else {
            setCart([]);
        }
    }, []);

    const handleRemoveItem = (productId) => {
        const updatedCart = cart.filter(item => item.id !== productId);
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };


    const handleQuantityChange = (productId, action) => {
        const updatedCart = cart.map(item => {
            if (item.id === productId) {
                let newQuantity = action === 'increment' ? item.quantity + 1 : item.quantity - 1;
    
                if (newQuantity < 1) {
                    setResponse('Product removed from cart.');
                    setTimeout(() => {
                        setResponse('');
                    }, 2000);            
                    return null;
                }
    
                return { ...item, quantity: newQuantity };
            }
            return item;
        }).filter(item => item !== null);
    
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const calculateTotal = () => {
        return cart.reduce((total, product) => total + parseFloat(product.sell_price) * product.quantity, 0).toFixed(2);
    };

    const calculateTotalItem = () => {
        return cart.reduce((total, product) => total + product.quantity, 0);
    };


        useEffect(() => {
            const fetchUserDetails = async () => {
                setLoading(true);
                try {
                    const response = await fetch('https://api.kcmstore.in/dist/get-users', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userId: userData.id, mobile: userData.mobile }),
                    });
    
                    setLoading(false);
    
                    if (!response.ok) {
                        throw new Error('Failed to fetch user data');
                    }
    
                    const data = await response.json();
                    setNewUserData(data);

                } catch (error) {
                    setLoading(false);
                    console.log(error.message);
                }
            };
    
            fetchUserDetails();
        }, [userData]);
    
    // const handlePlaceOrder = async (remark) => {
    //     setConfirmOrder(false);
    //     setLoading(true);
    //     const orderDetails = cart.map(product => ({
    //         product_id: product.id,
    //         product_name: product.name,
    //         product_unit: product.unit,
    //         image: product.image,
    //         product_org: product.org_price,
    //         product_sp: product.sell_price,
    //         quantity: product.quantity,
    //         product_tax: product.tax_amount,
    //         product_discount_type: product.discount_type,
    //         product_discount_amount: product.discount_amount,
    //     }));

    //     // Construct the order object
    //     const orderData = {
    //         order_items: orderDetails,
    //         total_price: calculateTotal(),
    //         payment_mode: 'Cash',
    //         payment_id: '',
    //         payment_status: 'pending',
    //         user_id: userData.id,
    //         remark: remark,
    //     };

    //     try {
    //         const response = await fetch('https://api.kcmstore.in/dist/place-order', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify(orderData),
    //         });

    //         setLoading(false);
    //         const result = await response.json();

    //         if (response.ok) {
    //             const pdf = await generateOrderPDF('invoiceArea');
    //             const blob = pdf.output('blob');
              
    //             const formData = new FormData();
    //             formData.append('file', blob, `order_invoice_${new Date().getTime()}.pdf`);
              
    //             // Upload PDF and get public URL (you need an API or upload service here)
    //             const pdfUploadRes = await fetch('https://api.kcmstore.in/dist/upload-file', {
    //               method: 'POST',
    //               body: formData,
    //             });
    //             const { pdfUrl } = await pdfUploadRes.json();
              
    //             // Then trigger WhatsApp message
    //             const message = `Hey! You got a new order. View invoice: ${pdfUrl}`;
    //             window.open(`https://wa.me/8957857276?text=${encodeURIComponent(message)}`, '_blank');


    //             setShowSuccess(true);
    //             setTimeout(() => {
    //                 setCart([]);
    //                 localStorage.removeItem('cart');
    //                 setShowSuccess(false);
    //             }, 3000);
    //         } else {
    //             setLoading(false);
    //             setResponse('Cannot place order. Please try again.');
    //             setTimeout(() => {
    //                 setResponse('');
    //             }, 2000);
    //         }
    //     } catch (error) {
    //         setLoading(false);
    //         console.log(error);
    //     };
    // };

    const handlePlaceOrder = async (remark) => {
        setConfirmOrder(false);
        setLoading(true);
    
        try {
            // const pdf = await generateOrderPDF('invoiceArea');
            // const blob = pdf.output('blob');
    
            // const formData = new FormData();
            // formData.append('file', blob, `order_invoice_${new Date().getTime()}.pdf`);
    
            // const uploadRes = await fetch('https://api.kcmstore.in/dist/upload-file', {
            //     method: 'POST',
            //     body: formData,
            // });
            // const data = await uploadRes.json();
    
            // if (!data || !data.fileUrl) {
            //     throw new Error('Failed to upload file.');
            // }
    
            // // 4. Open WhatsApp message with invoice link
            // const message = `Hey KCM Distributors!\nYou got a new order. Download invoice.\n${data.fileUrl}`;
            // window.open(`https://wa.me/8957857276?text=${encodeURIComponent(message)}`, '_blank');
    
            // // Wait 1-2 seconds to ensure WhatsApp tab opens
            // await new Promise((resolve) => setTimeout(resolve, 5000));
    
            // 5. Place the order in the backend
            const orderDetails = cart.map(product => ({
                product_id: product.id,
                product_name: product.name,
                product_unit: product.unit,
                image: product.image,
                product_org: product.org_price,
                product_sp: product.sell_price,
                quantity: product.quantity,
                product_tax: product.tax_amount,
                product_discount_type: product.discount_type,
                product_discount_amount: product.discount_amount,
                free: null,
            }));
    

const amtPay = (calculateTotal() - (calculateTotal() * newUserData.discount_allot / 100)).toFixed(2)

            const orderData = {
                order_items: orderDetails,
                total_price: amtPay,
                payment_mode: 'Cash',
                payment_id: '',
                payment_status: 'pending',
                user_id: userData.id,
                remark: remark,
            };
    
            // 6. Submit order data to backend
            const response = await fetch('https://api.kcmstore.in/dist/place-order', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(orderData),
            });
    
            const result = await response.json();
    
            if (response.ok) {
                setShowSuccess(true);
                setTimeout(() => {
                    setCart([]);
                    localStorage.removeItem('cart');
                    setShowSuccess(false);
                    navigate('/order-history');
                }, 3000);
            } else {
                setResponse('Cannot place order. Please try again.');
                setTimeout(() => setResponse(''), 2000);
            }
        } catch (error) {
            console.error(error);
            setResponse('Something went wrong while sending the order.');
            setTimeout(() => setResponse(''), 2000);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <>
            <section className='my-4'>
                <div className='px-4'>
                <button className='cursor-pointer border-0 bg-white' onClick={() => navigate('/dashboard')}><i class="fa-solid fa-angle-left fs-5"></i>
                <span className='profile-subheading ms-3'>Shopping Cart</span></button>
                
                <hr className='profile-hr' />


                {cart.length === 0 ? (
                    <div className='text-center my-5'>
                        <p className='fw-semibold'>No Items added in Cart</p>
                        <img src={extraImg} className='img-fluid' style={{ height: '16em' }} alt='empty cart' />
                    </div>
                ) : (
                    <>
                        <div className='cart-item-outer'>
                            {cart.map((product) => (
                                <div className='cart-item mb-3' key={product.id}>
                                    <div className='d-flex justify-content-between align-items-center'>

                                        <div className='d-flex text-start'>
                                            <img src={
    product.image
      ? `https://api.kcmstore.in/uploads/${product.image.split(',')[0]}`
      : Default
  } className='cart-item-img' alt={product.name} />

                                            <div className='ms-3 align-content-center'>
                                                <p className='product-name my-0'>{product.name} {product.unit ? `(${product.unit})` : ''}
                                                </p>
                                                <p className='product-price'>₹ {(product.sell_price * product.quantity).toFixed(2)}</p>
                                                <p>
                                                    <span className='action-btn' onClick={() => handleQuantityChange(product.id, 'decrement')}>-</span>
                                                    <span className='px-2'>{product.quantity}</span>
                                                    <span className='action-btn' onClick={() => handleQuantityChange(product.id, 'increment')}>+</span></p>
                                            </div>
                                        </div>

                                        <span className='text-secondary fs-3 cursor-pointer' onClick={() => handleRemoveItem(product.id)}><i class="fa-solid fa-delete-left"></i></span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className='bg-light px-3 py-3 rounded-3 mt-3'>
                            <p className='fw-bold'>Summary</p>
                            <div className='d-flex mb-1 para-text fw-semibold justify-content-between'><span>Total Items:</span><span>{calculateTotalItem()}</span> </div>
                            <div className='d-flex mb-1 para-text fw-semibold justify-content-between text-primary'><span>Order Total:</span><span>₹{calculateTotal()}</span> </div>    
                            {newUserData.discount_allot == null ? '' : 
                            <div className='d-flex justify-content-between text-danger'><span>Alloted Discount per Order:</span><span>{`${newUserData.discount_allot == null ? 'NA' : `${newUserData.discount_allot}%`}`}</span> </div>
                        }
                            <div className='d-flex mb-1 para-text fw-semibold justify-content-between text-success'><span>Amount to Pay:</span><span>₹{(calculateTotal() - (calculateTotal() * newUserData.discount_allot / 100).toFixed(2)).toFixed(2)}</span> </div>
                            </div>

                        <div className='mt-3 text-end'>
                            {/* <button className='login-btn' onClick={() => handlePlaceOrder()}>Place Order</button> */}
                            <button className='login-btn' onClick={() => setConfirmOrder(true)}>Place Order</button>
                        </div>
                    </>
                )}
</div>
            </section>

            {response && <ResponseMsg message={response} />}


{showSuccess && (
    <>
                    <section className='detail-dialog px-3 py-3'>
                    <div className='detail-dialog-inner mx-auto col-lg-8 col-md-10 col-12 py-3 px-3 bg-white text-center animate__animated animate__zoomIn'>
                        <span className='cursor-pointer float-end' onClick={() => setShowSuccess(false)}><i class="fa-solid fa-xmark"></i></span>
                        <img src={SuccessImg} className='img-fluid' />
                        <p className='profile-subheading'>Order Placed Successfully!</p>
                        <p className='text-muted fw-semibold'>Your order will be delivered soon. Thanks for choosing KCM Store.</p>
                    </div>
                </section>
    </>
)}

{confirmOrder && (
                <section className='detail-dialog px-3 py-3'>
                    <div className='detail-dialog-inner mx-auto rounded col-lg-8 col-md-10 col-12 py-5 px-3 bg-white animate__animated animate__zoomIn'>
                    <div className='what-invoice-area mb-4' id="invoiceArea">
                    <p className='profile-subheading'>Order Summary</p>

                            <p>Retailer Name: {userData.name}<br />Delivery Address: {userData.address || userData.location} {userData.city} {userData.state} {userData.pincode}</p>

                            <div className='what-table-responsive my-4'>
                            <hr />
                                <table className='w-100'>
                                    <tr>
                                    <th className='fw-semibold px-2'>Product</th>
                                    <th className='fw-semibold px-2'>Qty</th>
                                    <th className='fw-semibold px-2'>MRP</th>
                      <th className='fw-semibold px-2'>Discount</th>
                      <th className='fw-semibold px-2'>Tax Value</th>
                      <th className='fw-semibold px-2'>Sale Price</th>
                      <th className='fw-semibold px-2'>Total</th>
                                    </tr>

                                    {cart.map((product) => (
                                        <tr key={product.medicine_id}>
                                            <td className='px-2 py-2'>{product.name}</td>
                                            <td className='px-2 py-2'>{product.quantity}</td>
                                            <td className='px-2 py-2'>{product.org_price}</td>
                                            <td className='px-2 py-2'>{product.discount_type == 'amount' ? '₹' : ''}{product.discount_amount}{product.discount_type == 'percent' ? '%' : ''}</td>
                                            <td className='px-2 py-2 text-capitalize'>{product.tax_amount || "None"}</td>
                                            <td>₹{product.sell_price}</td>
                                            <td className='px-2 py-2'>₹{product.sell_price * product.quantity}</td>
                                        </tr>

                                    ))}

</table>
<hr />
                                </div>
                            {/* table area */}

                            <p className='fw-semibold my-0'>Total Items: {calculateTotalItem()}</p>
<p className='fw-semibold my-0 text-primary'>Order Total: ₹{calculateTotal()}</p>
{newUserData.discount_allot == null ? '' : 
                            <p className='fw-semibold text-danger my-0'>Alloted Discount per Order: {`${newUserData.discount_allot == null ? 'NA' : `${newUserData.discount_allot}%`}`}</p>
                        }
                            <p className='fw-semibold fw-semibold text-success'>Amount to Pay: ₹{(calculateTotal() - (calculateTotal() * newUserData.discount_allot / 100)).toFixed(2)}</p>

</div>


                        <div className="my-3">
          <label className="fw-semibold">Add a Remark (Optional):</label>
          <textarea
            className="profile-input mt-1"
            rows="3"
            placeholder="Enter your remark here..."
            value={orderRemark}
            onChange={(e) => setOrderRemark(e.target.value)}
          ></textarea>
        </div>


<div className='text-end'>
                        <button className='login-btn px-3 py-2 bg-danger' onClick={() => setConfirmOrder(false)}>Cancel</button>&nbsp;&nbsp;
                        <button className="login-btn px-3 py-2" onClick={() => handlePlaceOrder(orderRemark)}>Confirm Order</button>
                        </div>

                    </div>
                </section>
            )}


{loading && <Loading setLoading={setLoading} />}

        </>
    )
}

export default Cart
